@if (headings?.length > 0) {
  <aside class="print-details justify-content-start align-items-baseline">
    @for (heading of headings; track heading.label) {
      <div class="printable-heading">
        <strong class="d-block">{{ heading.label }}</strong>
        <span>{{ heading.value }}</span>
      </div>
    }
  </aside>
}